import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Helmet } from "react-helmet";

const NotAuthorized: FC = () => {
  const { logout } = useAuth0();

  return (
    <>
      <Helmet>
        <title>Sem Autorizacao - Agendamento</title>
      </Helmet>
      <Box bg="green.600" h="100vh" overflowY="auto" color="gray.800">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          bg="green.600"
          borderRadius="8px"
          h="calc(100vh - 8px)"
          p={6}
        >
          <Heading
            mb={5}
            fontSize={["40px", "40px", "50px"]}
            fontWeight="800"
            color="white"
          >
            Oops! Sem Autorização!
          </Heading>
          <Text
            maxW="460px"
            fontSize="18px"
            textAlign="center"
            fontWeight="800"
            color="white"
          >
            Por favor entre em contato com o time da Gestão de Estoque LEO para
            solicitar a liberação.
          </Text>

          <br></br>
          <Button
            backgroundColor={"yellow.100"}
            onClick={() => {
              // setLogout(true);
              logout({ returnTo: window.location.origin });
            }}
          >
            Retornar
          </Button>
        </Flex>
      </Box>
    </>
  );
};

export default NotAuthorized;
